import {
  faBoltLightning,
  faDollarSign,
  faHeadset,
  faLayerGroup,
  faSolarPanel,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RopFormsStepper from "../../../main/components/RopFormStepper";
const steps = [
  {
    label: "Dados do PVSyst",
    icon: <FontAwesomeIcon icon={faSolarPanel} />,
  },
  {
    label: "Valor do MWh",
    icon: <FontAwesomeIcon icon={faDollarSign} />,
  },
  {
    label: "UFV",
    icon: <FontAwesomeIcon icon={faBoltLightning} />,
  },
  {
    label: "Suporte",
    icon: <FontAwesomeIcon icon={faHeadset} />,
  },
  {
    label: "Cluster",
    icon: <FontAwesomeIcon icon={faLayerGroup} />,
  },
];

export default function UsinaFormsStepper(props: { activeStep: number }) {
  return <RopFormsStepper activeStep={props.activeStep} steps={steps} />;
}
